export default class ScreeningCriteriaClient {
    constructor(apiClient) {
        this.baseURI = '/v3/screening_criteria';
        this.apiClient = apiClient;
        this.getScreeningCriteriaMap = this.getScreeningCriteriaMap.bind(this);
        this.getScreeningCriteria = this.getScreeningCriteria.bind(this);
        this.getScreeningCriteriaVersions = this.getScreeningCriteriaVersions.bind(this);
        this.getScreeningCriteriaVersion = this.getScreeningCriteriaVersion.bind(this);
        this.postScreeningCriterion = this.postScreeningCriterion.bind(this);
        this.deleteScreeningCriterion = this.deleteScreeningCriterion.bind(this);
    }
    getScreeningCriteriaMap(config) {
        return this.apiClient.get(`${this.baseURI}`, config);
    }
    getScreeningCriteria(tripRequestId, config) {
        return this.apiClient.get(`${this.baseURI}/${tripRequestId}`, config);
    }
    getScreeningCriteriaVersions(tripRequestId, config) {
        return this.apiClient.get(`${this.baseURI}/${tripRequestId}/versions`, config);
    }
    getScreeningCriteriaVersion(tripRequestId, updateId, config) {
        return this.apiClient.get(`${this.baseURI}/${tripRequestId}/versions/${updateId}`, config);
    }
    postScreeningCriterion(tripRequestId, criterionName, config) {
        return this.apiClient.post(`${this.baseURI}/${tripRequestId}/${criterionName}`, {}, config);
    }
    deleteScreeningCriterion(tripRequestId, criterionName, config) {
        return this.apiClient.delete(`${this.baseURI}/${tripRequestId}/${criterionName}`, config);
    }
}
